import register from '@kpsys/angularjs-register';
import {ErpSidebarNavService} from './components/erp-sidebar-nav/erp-sidebar-nav.service';
import {ErpTopbarService} from './components/erp-topbar/erp-topbar.service';
import {ErpAiService} from 'src/features/erp/components/erp-ai/erp-ai.service';
import {FondPermissionsDataService} from 'src/features/erp/services/fond-permissions.data-service';
import {ErpFondPermissionsContextService} from 'src/features/erp/services/erp-fond-permissions-context.service';

export default register('portaro.features.erp', ['ui.router'])
    .service(ErpSidebarNavService.serviceName, ErpSidebarNavService)
    .service(ErpTopbarService.serviceName, ErpTopbarService)
    .service(ErpAiService.serviceName, ErpAiService)

    // Fond permissions
    .service(FondPermissionsDataService.serviceName, FondPermissionsDataService)
    .service(ErpFondPermissionsContextService.serviceName, ErpFondPermissionsContextService)

    .name();